import { render, staticRenderFns } from "./Boutique.vue?vue&type=template&id=1455c8b3&scoped=true"
import script from "./Boutique.vue?vue&type=script&lang=js"
export * from "./Boutique.vue?vue&type=script&lang=js"
import style0 from "./Boutique.vue?vue&type=style&index=0&id=1455c8b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1455c8b3",
  null
  
)

export default component.exports